export default __webpack_public_path__ + "static/media/main-category-events-venues.a5270a5c.jpg";